import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ReactiveAsteriskModule } from 'src/components/reactive-asterisk/reactive-asterisk.module';
import { SelectSearchModule } from 'src/components/select-search/select-search.module';
import { ModalModule } from 'src/shared/modal';
import { VendorCreditFormComponent } from './vendor-credit-form.component';
import { VendorCreditFormService } from './vendor-credit-form.service';

@NgModule({
  declarations: [VendorCreditFormComponent],
  providers: [VendorCreditFormService],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    ModalModule,
    ReactiveAsteriskModule,
    ReactiveFormsModule,
    FormsModule,
    SelectSearchModule,
  ]
})
export class VendorCreditFormModule { }
